import type {
	ReturnRequestDto,
	ShopMemberDto,
} from "@babackapp/private-api-client/types";
import {
	Avatar,
	AvatarFallback,
	AvatarImage,
} from "@babackapp/ui/components/avatar";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import AssignedMembersCombobox from "./assigned-members-combobox.tsx";

type AssignedMembersProps = {
	returnRequest: ReturnRequestDto;
};

type MemberLineProps = {
	member: ShopMemberDto;
};

function MemberLine({ member }: MemberLineProps) {
	const memberName =
		member.user?.firstName && member.user?.lastName
			? `${member.user.firstName} ${member.user.lastName}`
			: (member.user?.email ?? "Utilisateur inconnu");

	return (
		<div className="flex items-center space-x-2">
			<Avatar className="mr-2 h-6 w-6">
				<AvatarImage src={member.user?.logoUrl ?? ""} alt={memberName} />
				<AvatarFallback>{memberName.charAt(0)}</AvatarFallback>
			</Avatar>
			<span className="text-sm font-medium">{memberName}</span>
		</div>
	);
}

export default function AssignedMembers({
	returnRequest,
}: AssignedMembersProps) {
	const { data: shop } = useCurrentShopSuspense();

	return (
		<div>
			<div className="flex flex-col gap-2">
				<div className="space-y-2 my-2">
					{returnRequest.assignedUsers.map((userId) => {
						const member = shop.users.find((m) => m.userId === userId);
						if (!member) return null;

						return <MemberLine key={member.userId} member={member} />;
					})}
				</div>
			</div>
			<div>
				<AssignedMembersCombobox returnRequest={returnRequest} shop={shop} />
			</div>
		</div>
	);
}
